import { render } from "./UsersSalaryView.vue?vue&type=template&id=7beef87a"
import script from "./UsersSalaryView.vue?vue&type=script&lang=js"
export * from "./UsersSalaryView.vue?vue&type=script&lang=js"

import "./UsersSalaryView.vue?vue&type=style&index=0&id=7beef87a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__